var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sendCode",attrs:{"type":"primary","disabled":_vm.s !== _vm.up},on:{"click":_vm.send}},[(_vm.s === _vm.up)?_vm._t("default"):_c('div',[_vm._v(_vm._s(_vm.s)+"秒")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }